import { Table, Tag, Button, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

export function CostumeTable({
  costumes,
  filter,
  pagination,
  isLoading,
  onTableChange,
  onEdit,
  onDelete,
  userRole,
}) {
  const columns = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      render: (_, record, idx) => (filter.page - 1) * filter.limit + 1 + idx,
    },
    {
      title: "Người dùng",
      dataIndex: ["user", "name"],
      key: "userName",
      minWidth: 200,
      render: (name) => name || "N/A",
    },
    {
      title: "Email",
      dataIndex: ["user", "email"],
      key: "userEmail",
      minWidth: 200,
      render: (email) => email || "N/A",
    },
    {
      title: "Loại",
      dataIndex: "type",
      key: "type",
      render: (type) => (
        <Tag color={type === "borrow" ? "blue" : "green"}>
          {type === "borrow" ? "Mượn" : "Mua"}
        </Tag>
      ),
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      render: (size) => size || "N/A",
    },
    {
      title: "Số lượng",
      dataIndex: "quantity",
      key: "quantity",
      render: (quantity) => quantity || 1,
    },
    {
      title: "Trạng thái",
      key: "status",
      render: (_, record) => {
        const status =
          record.type === "borrow" ? record.borrowStatus : record.buyStatus;
        const statusOptions =
          record.type === "borrow"
            ? [
                { value: "pending", label: "Chờ nhận" },
                { value: "borrowed", label: "Đã mượn" },
                { value: "returned", label: "Đã trả" },
                { value: "lost", label: "Mất" },
                { value: "cancelled", label: "Đã hủy" },
              ]
            : [
                { value: "paid", label: "Đã thanh toán" },
                { value: "unpaid", label: "Chưa thanh toán" },
                { value: "cancelled", label: "Đã hủy" },
              ];
        const statusLabel =
          statusOptions.find((opt) => opt.value === status)?.label || status;
        return (
          <Tag
            color={
              status === "paid" || status === "returned"
                ? "green"
                : status === "cancelled"
                  ? "red"
                  : "blue"
            }
          >
            {statusLabel}
          </Tag>
        );
      },
    },

    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        date ? new Date(date).toLocaleDateString("vi-VN") : "N/A",
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
    },
    {
      title: "Thao tác",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          />
          {userRole === "admin" && (
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDelete(record._id)}
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={costumes}
      rowKey="_id"
      loading={isLoading}
      pagination={{
        current: filter.page,
        pageSize: filter.limit,
        total: pagination.total,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} mục`,
      }}
      onChange={onTableChange}
      scroll={{ x: 800 }}
    />
  );
}
